<template>
  <number-input
    v-model="model"
    :min="min"
    :max="max"
    :controls="controls"
    :inline="inline"
    rounded
    size="small"
    :error="error"
    :disabled="disabled"
    class="fts-integer"
    @blur="$emit('blur')"
  />
</template>
<script>
import Vue from 'vue';
import VueNumberInput from '../vue-number-input/number-input'
Vue.use(VueNumberInput);

import commons from '../commons/commons';

export default {
  props: {
    item: Object,
    formData: Object,
    value: Number,
    min: {
      type: Number,
      default: -999999999999,
    },
    max: {
      type: Number,
      default: 999999999999,
    },
    controls: Boolean,
    inline: Boolean,
    error: Boolean,
    disabled: Boolean
  },
  model: {
    prop: "value",
    event: "updateValue",
  },
	components: {
		'number-input': VueNumberInput
	},
	computed: {
		model: {
			get() {
        /* item.fieldName */
        if (this.item && this.item.fieldName) {
          return this.formData[this.item.fieldName];
        }
        /* value */
        else {
          return this.value;
        }
			},
			set(val) {
        const res = commons.isPossibleNumber(val) ? parseInt(val) : val;
        /* item.fieldName */
        if (this.item && this.item.fieldName) {
          this.$set(this.formData, this.item.fieldName, res);
        } 
        /* value */
        else {
          this.$emit('updateValue', res);
        }
        
				this.$emit('input', res);
			}
		}
	},
}
</script>